import { Directive, ElementRef, Input, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appHideIf]'
})
export class HideIfDirective {

  @Input() appHideIf!: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appHideIf']) {
      if (this.appHideIf) {
        this.renderer.setStyle(this.el.nativeElement, 'display', 'none');
      } else {
        this.renderer.removeStyle(this.el.nativeElement, 'display');
      }
    }
  }
}
